function Footer () {
    return (
      <p className="footer">
        Created at <a href="https://junocollege.com/">Juno College</a>
      </p>
    );
}

export default Footer;